import type { Location } from 'react-router';

/**
 * Create a canonical link for use in a `meta` function.
 * @see https://remix.run/docs/en/main/route/meta
 * @see https://developers.google.com/search/docs/crawling-indexing/consolidate-duplicate-urls
 */
export function canonicalTag(location: Location, menuUrl: string) {
  return {
    href: `${menuUrl}${location.pathname}`,
    rel: 'canonical',
    tagName: 'link',
  };
}
